import React, { useEffect, useState } from "react";
import { Trophy, Users, Target } from "lucide-react";
import { fetchStats } from "../lib/api";

const StatsSection = () => {
  const [stats, setStats] = useState({ winningTipsLastYear: 520, activeMembers: 675, averageWinRate: 78 });

  const load = async () => {
    try {
      const s = await fetchStats();
      setStats(s);
    } catch {}
  };

  useEffect(() => {
    load();
    const handler = () => load();
    window.addEventListener("ep-data-updated", handler);
    const iv = setInterval(load, 20000); // light poll so admin edits appear on other browsers
    return () => {
      window.removeEventListener("ep-data-updated", handler);
      clearInterval(iv);
    };
  }, []);

  const items = [
    { icon: Trophy, value: `${stats.winningTipsLastYear}+`, label: "Winning picks last year" },
    { icon: Users,  value: `${stats.activeMembers}+`,       label: "Active members" },
    { icon: Target, value: `${stats.averageWinRate}%+`,     label: "Average win rate" },
  ];

  return (
    <section className="bg-ep-royal-2 py-16 lg:py-20 border-y border-white/5">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-12">
          <div className="text-[#ff5a5a] font-semibold tracking-widest text-xs uppercase">
            About the tipster
          </div>
          <h2 className="text-white text-3xl sm:text-4xl font-bold mt-3">
            A track record that speaks for itself
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5 lg:gap-6">
          {items.map((it, i) => (
            <div key={i} className="card-lift bg-white rounded-2xl p-8 flex items-start gap-5 relative overflow-hidden">
              <div className="absolute -right-8 -top-8 w-32 h-32 rounded-full bg-[#ff5a5a]/8" />
              <div className="relative w-14 h-14 rounded-xl bg-[#ff5a5a]/10 flex items-center justify-center flex-shrink-0">
                <it.icon size={26} className="text-[#ff5a5a]" strokeWidth={2.2} />
              </div>
              <div className="relative">
                <div className="text-4xl lg:text-5xl font-extrabold text-[#0a1a4a]">{it.value}</div>
                <div className="mt-1 text-[#0a1a4a]/70 text-sm font-medium">{it.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
